import { Drawer, DrawerHeader } from "./drawer";

import { DrawerContent } from "./drawer";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./dialog";
import { Typography } from "./typography";
import { X } from "lucide-react";

// ResponsiveModal component types
interface ResponsiveModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
  direction?: "right" | "bottom";
}

// Main ResponsiveModal Component
export const ResponsiveModal: React.FC<ResponsiveModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  className = "",
  direction = "right",
}) => {
  const isDesktop = useMediaQuery("(min-width: 768px)");

  if (isDesktop) {
    return (
      <Dialog open={isOpen} onOpenChange={onClose}>
        <DialogContent className={`md:max-w-xl p-0 ${className}`}>
          <DialogHeader
            className={`px-6 py-5 md:pt-7 md:pb-5 md:px-8 border-b border-gray-50 ${
              !title ? "hidden" : ""
            }`}
          >
            <DialogTitle asChild>
              <Typography variant="bodySBold" className="mr-6">
                {title}
              </Typography>
            </DialogTitle>
          </DialogHeader>
          {children}
          <DialogFooter>{footer}</DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Drawer open={isOpen} onOpenChange={onClose} direction={direction}>
      <DrawerContent className={`!w-full pt-4 ${className}`}>
        {/* Header */}
        <DrawerHeader
          className={`px-3 py-4 border-b ${!title ? "hidden" : ""}`}
        >
          <div className="flex items-center justify-start">
            <button
              onClick={onClose}
              className="p-1.5 hover:bg-gray-100 rounded-md transition-colors"
              aria-label="Close"
            >
              <X className="h-5 w-5" />
            </button>
            <Typography variant="bodySBold" className="flex-1">
              {title}
            </Typography>
          </div>
        </DrawerHeader>

        {children}

        {/* Footer */}
        {footer && (
          <>
            <div className="border-t" />
            {footer}
          </>
        )}
      </DrawerContent>
    </Drawer>
  );
};
